<template>
  <v-autocomplete
    v-model="select"
    :items="subjects"
    :filter="filter"
    item-value="subjectId"
    :search-input.sync="search"
    :error-messages="errorMessages"
    flat
    :rounded="rounded"
    :label="labelText"
    :disabled="disabled"
    :clearable="clearable"
  >
    <template v-if="newButton" v-slot:append-outer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="newSubject"
          >
            mdi-plus
          </v-icon>
        </template>
        <span>{{ $t("component.subject_field.new") }}</span>
      </v-tooltip>
    </template>

    <template v-slot:selection="{ item }">
      <v-list-item-content>
        <v-list-item-title :class="{ 'grey--text': !item.active }">{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title :class="{ 'grey--text': !item.active }">{{ item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
/*
 * nodel input value format:
 *   subject object
 */
export default {
  name: "SubjectField",
  props: {
    value: {
      type: Object
    },
    rounded: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    newButton: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      select: null,
      search: null,
      subjects: null
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.name.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    setValue(value) {
      this.select = (value !== null) ? value.subjectId : null;
    },

    newSubject() {
      this.$emit("new-subject");
    }
  },

  watch: {
    select: function() {
      if (this.subjects !== null)
        this.$emit("input", this.subjects.find(x => x.subjectId === this.select) || null);
    },

    value:  function() {
      this.setValue(this.value);
    },

    "$store.state.auth.company": function() {
      this.$store.dispatch("data/fetchSubjects").then(subjects => {
        this.subjects = subjects.data.content;
      });
    },
  },

  computed: {
    labelText() {
      return (this.label !== null) ? this.label : this.$t("component.subject_field.title");
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchSubjects").then(subjects => {
      this.subjects = subjects.data.content;

      this.setValue(this.value);
    });
  }
};
</script>

<style scoped>

</style>